import { Box, Stack } from "@mui/material";
import { useAtom } from "jotai/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import RunningServicesModule from "@/module/running-services-module/running-services-module";
import { headerTitle } from "@/store/store";

const InstancePage = () => {
  const { t } = useTranslation();

  const [, setHeaderTitle] = useAtom(headerTitle);
  useEffect(() => {
    setHeaderTitle(t("instances"));
  }, [setHeaderTitle, t]);

  return (
    <>
      <Stack spacing={2} sx={{ height: "100%", flexWrap: "nowrap" }}>
        <Box sx={{ width: "83.333%" }}>
          <RunningServicesModule />
        </Box>
      </Stack>
    </>
  );
};

export default InstancePage;
